import { render, staticRenderFns } from "./RowInOlympicMatch.vue?vue&type=template&id=548ed711&scoped=true"
import script from "./RowInOlympicMatch.vue?vue&type=script&lang=js"
export * from "./RowInOlympicMatch.vue?vue&type=script&lang=js"
import style0 from "./RowInOlympicMatch.vue?vue&type=style&index=0&id=548ed711&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ed711",
  null
  
)

export default component.exports